module.exports = __webpack_public_path__ + "static/media/shield.4aab052e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/shield.svg
// module id = 300
// module chunks = 0